import * as React from "react";
import { Profile } from "./Profile/Profile";
import { profile } from "./profileData";
import "./style.css";

class App extends React.Component {
  public render() {
    return (
      <div className="App">
        <Profile profile={profile} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx